export enum ParseEntity {
  Message = 'Message',
  User = 'User',
}
